/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Show_PudosInputs */

const en_colleague_show_pudos = /** @type {(inputs: Colleague_Show_PudosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show PUDO depots`)
};

const ja_colleague_show_pudos = /** @type {(inputs: Colleague_Show_PudosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PUDO 拠点を表示`)
};

const fr_colleague_show_pudos = /** @type {(inputs: Colleague_Show_PudosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher les dépôts PUDO`)
};

const de_colleague_show_pudos = /** @type {(inputs: Colleague_Show_PudosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PUDO-Depots anzeigen`)
};

/**
* | output |
* | --- |
* | "Show PUDO depots" |
*
* @param {Colleague_Show_PudosInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_show_pudos = /** @type {((inputs?: Colleague_Show_PudosInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Show_PudosInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_show_pudos(inputs)
	if (locale === "ja") return ja_colleague_show_pudos(inputs)
	if (locale === "fr") return fr_colleague_show_pudos(inputs)
	return de_colleague_show_pudos(inputs)
});